import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Team.css";

import joinIllustration from "../../assets/join_team_illustration.png";

const TeamJoinForm = () => {
    const [selectedPosition, setSelectedPosition] = useState("");
    const formRef = useRef(null);

    const scrollToApply = () => {
        const element = document.getElementById("apply-section");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData(formRef.current);
        formData.append("form_type", "Ascent Team Application Form");

        try {
            const response = await fetch(
                "https://formsubmit.co/admin@ascentbw.com",
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (response.ok) {
                alert("Thank you! Your application has been submitted.");
                formRef.current.reset();
            } else {
                alert("Something went wrong. Please try again.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            alert("Network error. Please try again later.");
        }
    };

    return (
        <>
            {/* Join the Team Section */}
            <section className="join-team-section">
                <Container>
                    <div className="join-team-box shadow-sm">
                        <Row className="align-items-center g-5">
                            <Col lg={6}>
                                <div className="join-content">
                                    <h2 className="join-title">Join the Team <br /> Behind Ascent</h2>
                                    <p className="join-desc mt-4">
                                        Join a team of passionate creators working together to shape meaningful brand experiences.
                                    </p>
                                    <div className="join-actions mt-5">
                                        <button className="btn-apply-now" onClick={scrollToApply}>Apply For Job</button>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} className="text-center">
                                <motion.img
                                    initial={{ opacity: 0, scale: 0.95 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.8 }}
                                    src={joinIllustration}
                                    alt="Illustration"
                                    className="join-illustration img-fluid"
                                />
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>

            {/* Application Form Section */}
            <section className="apply-form-section" id="apply-section">
                <Container>
                    <div className="apply-container text-center">
                        <h2 className="apply-title">Apply to Join Our Team</h2>
                        <p className="apply-subtitle mt-4 mb-5">
                            Share a few details about yourself and the role you're interested in. Our team will review your application and get back to you shortly.
                        </p>

                        <motion.div
                            className="apply-card shadow-lg mx-auto"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                        >
                            <form ref={formRef} onSubmit={handleSubmit} className="team-form" encType="multipart/form-data">
                                <Row className="g-4">
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Name</label>
                                        <input type="text" name="name" className="form-control-custom" placeholder="Your Name" required />
                                    </Col>
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Email Address</label>
                                        <input type="email" name="email" className="form-control-custom" placeholder="Email Address" required />
                                    </Col>
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Phone Number</label>
                                        <input type="tel" name="phone" className="form-control-custom" placeholder="Phone Number" required />
                                    </Col>
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Position Applied For</label>
                                        <select 
                                            name="position" 
                                            className="form-control-custom" 
                                            required 
                                            value={selectedPosition}
                                            onChange={(e) => setSelectedPosition(e.target.value)}
                                        >
                                            <option value="" disabled>Select Position</option>
                                            <option value="Digital Marketing Intern">Digital Marketing Intern</option>
                                            <option value="Video Editor Intern">Video Editor Intern</option>
                                            <option value="Full Stack Developer">Full Stack Developer</option>
                                            <option value="Graphic Designer">Graphic Designer</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </Col>

                                    {selectedPosition === "Other" && (
                                        <Col md={6} xs={12} className="text-start">
                                            <label className="form-label-custom">Specify Position</label>
                                            <input 
                                                type="text" 
                                                name="other_position" 
                                                className="form-control-custom" 
                                                placeholder="Enter position name" 
                                                required 
                                            />
                                        </Col>
                                    )}
                                    <Col xs={12} className="text-start">
                                        <label className="form-label-custom">Portfolio / LinkedIn URL</label>
                                        <input type="url" name="portfolio" className="form-control-custom" placeholder="https://..." required />
                                    </Col>
                                    <Col xs={12} className="text-start">
                                        <label className="form-label-custom">Upload CV / Resume</label>
                                        <input
                                            type="file"
                                            name="attachment"
                                            className="form-control-custom resume-upload"
                                            accept=".pdf,.doc,.docx"
                                            required
                                        />

                                        <small className="text-muted mt-1 d-block">Accepted formats: PDF, DOC, DOCX (Max 5MB)</small>
                                    </Col>
                                    <Col xs={12} className="text-start">
                                        <label className="form-label-custom">Why do you want to join Ascent?</label>
                                        <textarea name="message" className="form-control-custom" rows="4" placeholder="Tell us about yourself..." required></textarea>
                                    </Col>

                                    {/* Hidden FormSubmit config */}
                                    <input type="hidden" name="_captcha" value="false" />
                                    <input type="hidden" name="_template" value="table" />
                                    <input
                                        type="hidden"
                                        name="_subject"
                                        value="New Job Application - Ascent Team Page"
                                    />

                                    <Col xs={12}>
                                        <button type="submit" className="btn-submit-team">Submit Application</button>
                                    </Col>
                                </Row>
                            </form>
                        </motion.div>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default TeamJoinForm;
